export default {
  model: [
    {
      label: 'Revista',
      field: 'magazine_id',
      type: 'text'
    },
    {
      label: 'Nº da Edição',
      field: 'edition_number',
      type: 'text'
    },
    {
      label: 'Nº da Página',
      field: 'page_number',
      type: 'text'
    },
    {
      label: 'Texto',
      field: 'text_id',
      type: 'text'
    }
  ]
}